import React from "react";

const AboutStanding = () => {
  return (
    <div className="about_standing container">
      <p
          style={{
            color: "#000",
            fontSize: "18px",
            marginBottom: "5px",
            position: "relative",
            width: "fit-content",
          }}
        >
          The MetBrains Way
          <span
            style={{
              position: "absolute",
              bottom: "0px",
              left: "0px",
              right: "0px",
              height: "2px",
              background:
                "linear-gradient(to right, #006bff, #006bff 50%, #ff8000 50%)",
            }}
          ></span>
        </p>

        <h5 style={{ fontSize: "32px" }}>
          What We Stand For
        </h5>
      <p style={{marginBlock:"24px"}}>
        At Metbrains, our purpose is guided by three core principles: <strong>Empower Learners, Bridge Knowledge and Practice, and Lead with Integrity</strong>.
        These values shape how we mentor learners, design programs, and build our community. We listen deeply to aspirations, co-create solutions that address real-world challenges, and foster growth that is both meaningful and lasting.
      </p>

      <div className="about_standing_flex">
        <div className="about_standing_card">
          <h4>Empower Learners</h4>
          <p>
            We believe every learner has the potential to achieve extraordinary growth. By focusing on hands-on training, mentorship, and personalized guidance, we empower individuals to take charge of their careers with confidence.
          </p>
        </div>
        <div className="about_standing_card">
          <h4>Bridge Knowledge and Practice</h4>
          <p>
            True expertise comes from applying what you learn. That’s why we integrate real-world projects, industry case studies, and practical insights into every program—ensuring knowledge transforms into career-ready skills.
          </p>
        </div>
        <div className="about_standing_card">
          <h4>Lead with Integrity</h4>
          <p>
            We are committed to doing what’s right for our learners and partners. Transparency, trust, and accountability define our approach, so every mentorship journey is grounded in ethics and long-term success.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutStanding;
